(function () {
  'use strict';

  _.once(function () {
    // fetch info data before start app
    var $q = angular.injector(['ng']).get('$q'),
      $http = angular.injector(['ng']).get('$http'),
      requests = [],
      isLocalDev = _.find(
        ['diviaclocal', '192.168', 'localhost', 'travellocal'],
        function (str) {
          return _.includes(window.location.host, str);
        }
      ),
      isStage = _.find(['travel.padi.comingsoon.rocks'], function (str) {
        return _.includes(window.location.host, str);
      }),
      isDev = _.find(['padi.nearlydone.rocks'], function (str) {
        return _.includes(window.location.host, str);
      }),
      isInprogress = _.find(['travel.padi.inprogress.rocks'], function (str) {
        return _.includes(window.location.host, str);
      }),
      server = '//travel.padi.com/api/v2/travel/info/',
      menu = '//travel.padi.com/api/v2/travel/menu',
      experimentIdDr = 'thRslaMWT4aqTHA-GF8wkA',
      aud = '503u87mvc25i53veank5m32e6i',
      experimentIdLa = '5c7mihWSQjqquM-eRABC-A';

    if (isLocalDev) {
      aud = '7u0q6o7jbqck26k2adbdu6qbjk';
      server = 'https://travel.padi.localhost/api/v2/travel/info/';
      menu = 'https://travel.padi.localhost/api/v2/travel/menu/';
      // experimentId = 'LHyU6NLySDi-lnj1xcRI8Q';
    } else if (isStage) {
      aud = '7u0q6o7jbqck26k2adbdu6qbjk';
      server = '//travel.padi.comingsoon.rocks/api/v2/travel/info/';
      menu = '//travel.padi.comingsoon.rocks/api/v2/travel/menu/';
    } else if (isDev) {
      aud = '7u0q6o7jbqck26k2adbdu6qbjk';
      server = 'https://travel-np.padi.com/api/v2/travel/info/';
      menu = 'https://travel-np.padi.com/api/v2/travel/menu/';
      // experimentId = 'LHyU6NLySDi-lnj1xcRI8Q';
    } else if (isInprogress) {
      aud = '7u0q6o7jbqck26k2adbdu6qbjk';
      server = 'https://travel.padi.inprogress.rocks/api/v2/travel/info/';
      menu = 'https://travel.padi.inprogress.rocks/api/v2/travel/menu/';
    }

    var localStorageIsSupported = true;
    if (typeof localStorage === 'object') {
      try {
        localStorage.setItem('localStorage', 1);
        localStorage.removeItem('localStorage');
        localStorageIsSupported = true;
      } catch (e) {
        // Storage.prototype._setItem = Storage.prototype.setItem;
        // Storage.prototype.setItem = function() {};
        // alert('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.');
        localStorageIsSupported = false;
      }
    }

    if (
      localStorageIsSupported &&
      localStorage.getItem('testMode') &&
      localStorage.getItem('testMode') === 'test'
    ) {
      server = 'https://travel-np.padi.com/api/v2/travel/info/';
      menu = 'https://travel-np.padi.com/api/v2/travel/menu/';
    }

    requests.push($http.get(server));
    requests.push($http.get(menu));

    window.LANGUAGES = ['en', 'fr', 'de', 'es', 'it'];

    if (!getCookie('travel_language')) {
      var language, langCode;

      if (window.navigator.languages && window.navigator.languages.length) {
        _.each(window.navigator.languages, function (val) {
          langCode = val.split('-');
          if (
            window.LANGUAGES.indexOf(langCode[0]) !== -1 &&
            !window.requireRedirect
          ) {
            window.requireRedirect = langCode[0];
          }
        });
      } else {
        language = window.navigator.language || window.navigator.userLanguage;
        if (language) {
          langCode = language.split('-');

          if (window.LANGUAGES.indexOf(langCode[0]) !== -1) {
            window.requireRedirect = langCode[0];
          }
        }
      }
    }

    var langPrefix = window.location.pathname.match(/^\/[a-z]{2,3}\//),
      lang = 'en';

    if (langPrefix) {
      if (langPrefix[0] === '/ach/') {
        lang = 'ach';
      } else {
        lang = langPrefix[0].substr(1, 2);
      }
    }

    document.documentElement.setAttribute('lang', lang);
    document.body.classList.add('lang-' + lang);

    setCookie('travel_language', lang, {
      path: '/',
      domain: '.' + window.location.hostname.split('.').splice(1).join('.'),
      expires: 3600 * 24 * 7 /* 7 days */,
    });

    window.lang = lang;

    $q.all(requests).then(function (res) {
      if (res.length) {
        angular.element(document).ready(function () {
          var info = res[0].data;
          info.experimentIdLa = experimentIdLa;
          info.experimentIdDr = experimentIdDr;
          angular.module('app').constant('info', info);
          angular.module('app').constant('selectedLanguage', lang);

          if (res[1].data) {
            menu = res[1].data;
            _.forOwn(menu, function (item, key) {
              item.code = key;
            });
            angular.module('app').constant('megaMenu', menu);
          }

          const sub = getCookie(`CognitoIdentityServiceProvider.${aud}.LastAuthUser`),
            idToken = getCookie(`CognitoIdentityServiceProvider.${aud}.${sub}.idToken`);
          if (!idToken) {
            const userData = getCookieByRegexp('CognitoIdentityServiceProvider.*.*.userData');
            if (userData) {
              const options = {
                domain: '.' + window.location.hostname.split('.').splice(1).join('.'),
                path: '/',
                expires: 3600, // 1 hour
              };
              setCookie('login_next_page', window.location.href, options);
              const parsedUserData = JSON.parse(userData),
                subValue = parsedUserData.UserAttributes.find(item => item.Name === 'sub').Value,
                audValue = parsedUserData.UserAttributes.find(item => item.Name === 'aud').Value,
                tokenCookieName = `CognitoIdentityServiceProvider.${audValue}.${subValue}.idToken`,
                refreshTokenCookieName = `CognitoIdentityServiceProvider.${audValue}.${subValue}.refreshToken`,
                token = getCookie(tokenCookieName),
                refreshToken = getCookie(refreshTokenCookieName);

              if (token && refreshToken) {
                const refershUrl = window.location.origin === 'https://travel.padi.com'
                  ? 'https://api.global-prod.padi.com/auth/api/oauth/refresh'
                  : 'https://api-stage.global-np.padi.com/auth/api/oauth/refresh/';

                return window.fetch(refershUrl, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                  },
                  body: JSON.stringify({
                    refreshToken,
                    clientId: aud,
                    idToken: token,
                  }),
                }).then(response => response.json()).then(newToken => {
                  if (newToken && newToken.idToken) {
                    window.location.href = `/cognito_auth/?id_token=${newToken.idToken}&refresh_token=${newToken.refreshToken}`;
                  } else {
                    deleteCookie(tokenCookieName);
                    deleteCookie(refreshTokenCookieName);
                    deleteCookie(`CognitoIdentityServiceProvider.${audValue}.${subValue}.userData`);
                  }
                  return true;
                });
              }
            }
          }
          angular.bootstrap(document, ['app']);
          return true;
        });
      }
    });

    function setCookie(name, value, options) {
      options = options || {};

      var expires = options.expires;

      if (typeof expires === 'number' && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
      }
      if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
      }

      value = encodeURIComponent(value);

      var updatedCookie = name + '=' + value;
      /* eslint-disable guard-for-in */
      for (var propName in options) {
        updatedCookie += '; ' + propName;
        var propValue = options[propName];
        if (propValue !== true) {
          updatedCookie += '=' + propValue;
        }
      }
      document.cookie = updatedCookie;
    }

    function getCookie(name) {
      var matches = document.cookie.match(
        new RegExp(
          '(?:^|; )' +
            name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
            '=([^;]*)'
        )
      );
      return matches ? decodeURIComponent(matches[1]) : null;
    }

    function deleteCookie(name) {
      document.cookie =
        name +
        '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=' +
        '.' +
        window.location.hostname.split('.').splice(1).join('.')
      return true;
    }

    function getCookieByRegexp(name) {
      var matches = document.cookie.match(new RegExp(
        '(?:^|; )' + name + '=([^;]*)'
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    }
  })();
})(window);
